/*
 * ------------------------------------------
 * File Name: kp-countdown.js
 * Description: This file contains the JavaScript code for handling the "coming soon" countdown timer
 *              for products. It fetches the current server time, calculates the time difference between 
 *              the server and client, and displays the countdown timer accordingly.
 * Author: Jahnavi Gottimukkala
 * Date Created: 10-01-2026
 * Last Modified: 10-01-2026
 * Version: 1.0
 * ------------------------------------------
 *
 * Usage:
 *   - Include this script in the relevant HTML files where the countdown timer needs to be displayed.
 *   - Ensure moment.js and jQuery libraries are loaded before this script.
 *
 * Functions:
 *   - fetchRealTime: Asynchronously fetches the current server time.
 *   - ks_Countdown_date_formatter: Formats the date in 'YYYY-MM-DD HH:mm:ss' format.
 *   - ksComingSoonProducts: Initializes and manages the countdown timers for single products and product grids.
 *
 * Dependencies:
 *   - moment.js: A JavaScript date library for parsing, validating, manipulating, and formatting dates.
 *   - moment-timezone.js: A plugin for moment.js that provides timezone support.
 *   - jQuery: A fast, small, and feature-rich JavaScript library.
 *
 * Note:
 *   - Ensure the server time endpoint 'https://us-central1-curren-time.cloudfunctions.net/currentTime' is active.
 *   - The script handles different time zones to provide a consistent user experience.
 */


$(function() { 

	async function fetchRealTime() {
		try {
			let response = await fetch('https://us-central1-curren-time.cloudfunctions.net/currentTime');
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			let realTime = await response.json();
			realTime = parseInt(realTime.data);
			return realTime;
		} catch(e) {
			console.log(e);
		}
	}

	// Immediately initialize the countdown with server or client time
	fetchRealTime().then((serverDate) => {
		if (!serverDate) {
			serverDate = new Date().getTime(); // Fallback to client time if no server time
		}
		initializeCountdowns(serverDate); // Initialize countdowns for both products and collections
	}).catch(error => {
		console.log("Error initializing countdown:", error);
		let clientDate = new Date().getTime();
		initializeCountdowns(clientDate); // Fallback to client time if error
	});

	function initializeCountdowns(serverDate) {
		// Initialize for product and collection timers
		ksComingSoonProducts(serverDate);

		// Reinitialize for dynamically loaded product and collection sections
		checkForDynamicSections(serverDate);
	}

	// Monitor dynamic sections and initialize countdown for both products and collections
	function checkForDynamicSections(serverDate) {
		// Use MutationObserver if sections are dynamically inserted
		const observer = new MutationObserver(function(mutationsList) {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					// Look for newly added product or collection timers
					let productTimers = document.querySelectorAll('.product-single__coming-soon-timer:not(.initialized)');
					let collectionTimers = document.querySelectorAll('.coming-soon-tag:not(.initialized)');

					// Initialize countdown for new product pages
					if (productTimers.length > 0) {
						productTimers.forEach(function(timer) {
							timer.classList.add('initialized'); // Prevent re-initialization
							initializeTimer(timer, serverDate, "single"); // Initialize specific countdown
						});
					}

					// Initialize countdown for new collection sections
					if (collectionTimers.length > 0) {
						collectionTimers.forEach(function(timer) {
							timer.classList.add('initialized'); // Prevent re-initialization
							initializeTimer(timer, serverDate, "grid"); // Initialize specific countdown
						});
					}
				}
			}
		});

		// Observe the entire body for added nodes (can be narrowed down)
		observer.observe(document.body, { childList: true, subtree: true });
	}
});

function ks_Countdown_date_formatter(date) {
	var countdownDate = moment(date).format('YYYY-MM-DD HH:mm:ss');
	return countdownDate;
}

// Function to initialize the countdown for a specific timer element
function initializeTimer(timerElement, serverDate, type) {
  // Get the client's machine time
  var clientDate = new Date().getTime();
  var difference = (serverDate - clientDate) / 1000;
  
  // Pull the data-date from the specific DOM element
  var coming_soon = $(timerElement).data("date");
  if (coming_soon) {
    let formattedDate = ks_Countdown_date_formatter(coming_soon);
	let launchDate = moment.tz(formattedDate, "UTC");
	let timeToLaunch = launchDate - serverDate;
	let countDownTime = clientDate + timeToLaunch;
	let releaseDate = ks_Countdown_date_formatter(countDownTime);
	let myTimezone = moment.tz.guess();
	let helsinki = moment.tz(launchDate, "Europe/Helsinki");
	let myTime = helsinki.clone().tz(myTimezone);

    if (type === 'single') {
    	// Initialize the countdown for this specific element
    	$(timerElement).countdown(releaseDate, function(event) {
            let daysLeft = event.offset.totalDays;
            let dayText = daysLeft === 1 ? 'day' : 'days';
            let timeText = event.strftime('%H:%M:%S');
        	$(this).html(`${daysLeft} ${dayText} ${timeText}`);
        	if (event.elapsed) {
    			$(this).closest('.product-single__coming-soon').hide();
                $(this).parents('.product__info-container').find('.product-form__input').show();
    			$(this).parents('.product__info-container').find('.buy-buttons-row').show();
    			$(this).parents('.product__info-container').find('.product__inventory').removeClass('coming-soon-product');
    		} else {
    			$(this).closest('.product-single__coming-soon').show();
    			$(this).parents('.product__info-container').find('.buy-buttons-row').hide();
    			$(this).siblings('.product-single__coming-soon-timing').text('Release date: ' + myTime.format("MMMM Do YYYY, h:mm a"));
    		}
    	});
        $(timerElement).on('finish.countdown', function() {
    		$(this).closest('.product-single__coming-soon').hide();
            $(this).parents('.product__info-container').find('.product-form__input').show();
    		$(this).parents('.product__info-container').find('.buy-buttons-row').show();
    		$(this).parents('.product__info-container').find('.product__inventory').removeClass('coming-soon-product');
    	});
    } else if (type === 'grid') {
        // Product Grid Countdown Logic (Collection)
    	$(timerElement).countdown(releaseDate, function(event) {
            let daysLeft = event.offset.totalDays;
            let dayText = daysLeft === 1 ? 'day' : 'days';
            let timeText = event.strftime('%H:%M:%S');
    		// Update the countdown text
    		$(this).find(".coming-soon-tag-countdown").text(`${daysLeft} ${dayText} ${timeText}`);
    					
    		// Hide and show based on countdown event
    		if (event.elapsed) {
        		$(this).hide();
    		} else {
    			$(this).show();
    		}
    	});
        $(timerElement).on('finish.countdown', function() {
    		$(this).hide();
    	});
    }
  }
}

function ksComingSoonProducts(serverDate) {
    console.log("Trying to show the product launch timing show"+$('.product-single__coming-soon-timer').length);
	// Single Product Countdown
	$('.product-single__coming-soon-timer').each(function() {
    	initializeTimer(this, serverDate, "single"); // Initialize each timer individually
	});

	// Product Grid Countdown
	$('.coming-soon-tag').each(function() {
    	initializeTimer(this, serverDate, "grid"); // Initialize each timer individually
	});
}
